let shTarget = document.querySelector('.announcement-bar-section');
let siteHeader = document.querySelector('.header-wrapper');

window.addEventListener('load', (event) => {
	//let shTarget = document.querySelector('#wt-top-banner');
  //console.log(shTarget);

  createObserver();
}, false);

function createObserver() {
  let observer;

  let options = {
    root: null,
    rootMargin: "0px",
    threshold: [0, 1]
  };

  observer = new IntersectionObserver(observerFunc, options);
  observer.observe(shTarget);
}

function observerFunc(entries) {
	entries.forEach(function(entry) {
		let eir = entry.intersectionRatio;
		if (eir < 1) {
			siteHeader.classList.add('pinned');
		} else {
			siteHeader.classList.remove('pinned');
		}
	  });
}
let wtMPopup = document.querySelector('#wt-product-media-popup');
let wtMPClose = document.querySelector('#wt-product-media-popup-close');
let wtArrows = document.querySelectorAll('.wt-arrow');
let wtMWrap = document.querySelector('.wt-product-media-wrap');
let wtThumbs = document.querySelectorAll('.product-single__thumbnails-item');
let wtThumbAs = document.querySelectorAll('.product-single__thumbnail');
let wtpms = document.querySelectorAll('.wt-product-media');
let wtPopTrigs = document.querySelectorAll('.wt-popup-trigger');

if(wtMPopup) {
  wtMPClose.addEventListener('click', () => {
     let t = wtMPClose.getAttribute('data-href');
  	let tel = document.querySelector(t);
  	tel.classList.remove('visible');
  wtpms.forEach((wtpm) => {
    wtpm.classList.remove('active');
  });
});
	wtArrows.forEach((wtArrow) => {
      wtArrow.addEventListener('click', () => {
                               
        let sd = parseInt(wtArrow.getAttribute('data-wt-trigger'));
      	let pml = wtMWrap.getAttribute('data-wt-popup-slide-count');
      	let apml = parseInt(pml - 1);
      	let cs = document.querySelector('.wt-product-media.active');
      	let csi = parseInt(cs.getAttribute('data-wt-popup-index'));
      	let nia = 0;
      	let ni = parseInt(csi + sd);
        if(ni < 0) {
			 nia = apml;
        } else if(ni > apml) {
           nia = 0;
        } else {
           nia = ni;
        }
      let ns = document.querySelector('[data-wt-popup-index="' + nia + '"]');
      let nt = document.querySelector('[data-slider-slide-index="' + nia + '"] .product-single__thumbnail');
      cs.classList.remove('active');
      ns.classList.add('active');
      nt.click();
      
      });
	});
	
wtPopTrigs.forEach((wtPopTrig) => {
  wtPopTrig.addEventListener('click', (e) => {
    //console.log('trig');
    e.preventDefault();
    //e.stopPropagation();
     let ssi = wtPopTrig.getAttribute('data-slider-slide-index');
      let cps = document.querySelector('[data-wt-popup-index="' + ssi + '"]');
  wtpms.forEach((wtpm) => {
    wtpm.classList.remove('active');
  });
      wtMPopup.classList.add('visible');
      cps.classList.add('active');
     });
  
});
}

/*const wtProductThumbs = document.querySelector('.grid__item.product-single__media-group .thumbnails-wrapper');
const wttas = document.querySelectorAll('.wt-thumbnails-arrow');
if(wttas) {
  console.log('11 11 24');
wttas.forEach((wtta) => {
	wtta.addEventListener('click', () => {
		let wttad = wtta.getAttribute('data-direction');
		let wtptd = wtProductThumbs.scrollTop;
  		let wtptl = wtProductThumbs.scrollLeft;
		//console.log('clicked ' + wttad + ' ' + wtptd);
		if(wttad === 'down') {
			wtProductThumbs.scrollTop = wtptd + 110;
		} else if(wttad === 'up') {
			wtProductThumbs.scrollTop = wtptd - 110;
		} else if(wttad === 'right') {
          	wtProductThumbs.scrollLeft = wtptl + 110;
        } else if(wttad === 'left') {
          	wtProductThumbs.scrollLeft = wtptl - 110;
        }
		
	});
});
}*/

let wtmcnlpopWrap = document.querySelector('.wt-mc-nl-popup-wrap');
let wtmcnlpopClosers = document.querySelectorAll('[class*="wt-mc-nl-popup-close"]');
let mcptime = localStorage.getItem('mcPtime');
let mcsup = localStorage.getItem('mcSignup');
let noPint = 864000000;
let wtnow = Date.now();
//console.log('NOW:  ' + wtnow);
//console.log('THEN: ' + mcptime);

/*if(wtmcnlpopWrap) {
  console.log('NOW:  ' + wtnow);
console.log('THEN: ' + mcptime);
if( !mcsup && wtnow > mcptime + noPint ) {
  setTimeout(() => {
    wtmcnlpopWrap.classList.add('visible');
  }, 8000);
}
}*/

if(wtmcnlpopClosers) {
  wtmcnlpopClosers.forEach((wpc) => {
    wpc.addEventListener('click', () => {
      wtmcnlpopWrap.classList.remove('visible');
      let clicktime = Date.now();
      localStorage.setItem('mcPtime', clicktime);
    });
  });
} 

let mcSubmit = document.getElementById('mc-embedded-subscribe');
let wtmcSubmit = document.getElementById('wt-mc-embedded-subscribe');
if(wtmcSubmit) {
  wtmcSubmit.addEventListener('click', () => {
      let clicktime = Date.now();
      localStorage.setItem('mcPtime', clicktime);
      localStorage.setItem('mcSignup', true);
    console.log('mc clicked');
    mcSubmit.click();
    });
} 
if(mcSubmit) {
  mcSubmit.addEventListener('click', () => {
      let clicktime = Date.now();
      localStorage.setItem('mcPtime', clicktime);
      localStorage.setItem('mcSignup', true);
    console.log('mc clicked');
    //mcSubmit.click();
    });
}
window.onkeydown = function( event ) {
    if ( event.keyCode == 27 ) {
        let visPopup = document.querySelector('[class*="popup"].visible');
		if(visPopup) {
			visPopup.classList.remove('visible');
		}
    }
};

let shopdpwc = document.querySelector('delivery-promise-wc');
if(shopdpwc) {
  shopdpwc.remove();
}
function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
let cloc = readCookie('_ks_countryCodeFromIP');
let wtfsd = document.querySelector('.wt-free-shipping-diff');
let wtuoe = document.querySelector('.wt-order-update-error');

if(wtfsd) {
    wtfsd.setAttribute('data-wt-country', cloc)
}
(function(ns, fetch) {
  if (typeof fetch !== 'function') return;

  ns.fetch = function() {
    const response = fetch.apply(this, arguments);

    response.then(res => {
      if ([
          `${window.location.origin}/cart/add.js`,
          `${window.location.origin}/cart/update.js`,
          `${window.location.origin}/cart/change.js`,
          `${window.location.origin}/cart/clear.js`,
        ].includes(res.url)) {
        res.clone().json().then(data => {
          //console.log(data);
          ustatus = data.status;
          if(ustatus == 422) {
            let umessage = data.message;
            if(wtuoe) {
              wtuoe.classList.remove('hide');
              wtuoe.textContent = umessage;
            }
          } else {
            if(wtuoe) {
              wtuoe.classList.add('hide');
            }
            let cprice = data.total_price / 100;
            let ndiff = 250 - cprice;
            let nd = ndiff / 250;
            let ndp = nd * 100;
            let ndper = 100 - ndp;
            if(wtfsd) {
              if(ndiff > 0) {
                wtfsd.innerHTML = 'You are <strong>$<span id="wt-fsd-amt">' + ndiff + '</span></strong> away from Free Shipping<div class="gauge"><span class="gauge-amount" style="width: ' + ndper + '%;"></span></div>';
              } else {
                wtfsd.innerHTML = "You've qualified for Free Shipping!";
              }
            }
          }         
        })
      }
    });

    return response;
  }

}(window, window.fetch))

/*let vpickers = document.querySelectorAll('.select__select');
let wtbtntxt = document.querySelector('#wt-add-to-cart-text');
if(vpickers) {
vpickers.forEach((vpicker) => {
  document.body.addEventListener('change', (event) => {
    if(event.target.matches('.select__select')) {
      console.log('changed');
      let cpol = vpicker.getAttribute('data-cvariant-pol');
      let cqty = parseInt(vpicker.getAttribute('data-cvariant-qty'));
      let wtbmessage = document.createElement('div');
      wtbmessage.classList.add('wt-backorder-message');
      wtbmessage.textContent = 'Ships in 1-3 weeks';
      if( cpol == 'continue') {
        if(cqty < 1) {
          console.log('yes');
          wtbtntxt.appendChild(wtbmessage);
        } else {
          console.log('no');
          
        }   
      } 
    }
  });
});
}*/
